import { ET_TIMEZONE, JUST_SHOW_BARRIERS_WEEKDAYS_ET } from '@/constant';

const capitalize = (value?: string | null): string => {
    if (value == null || value.trim() === '') return '-';
    const t = value.trim().toLowerCase();
    return t.charAt(0).toUpperCase() + t.slice(1);
};
const truncateText = (value?: string | null, length: number = 300): string => {
    if (value == null || value.trim() === '') return '-';
    const TrimmedValue = value.trim();
    return TrimmedValue.length > length ? TrimmedValue.slice(0, length) + '...' : TrimmedValue;
};

const getEtWeekdayShort = (date = new Date()) => new Intl.DateTimeFormat('en-US', { timeZone: ET_TIMEZONE, weekday: 'short' }).format(date);
const justShowBarriersWeekdaysEt = () => JUST_SHOW_BARRIERS_WEEKDAYS_ET.has(getEtWeekdayShort());
const getDateWithFileTypeString = (fileType: string) => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');

    return `${mm}-${dd}-${yyyy}.${fileType}`;
};
const getDownload = (data: BlobPart, filename: string, mimeType = 'application/octet-stream') => {
    const blob = new Blob([data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the object URL to prevent memory leaks
    window.URL.revokeObjectURL(url);
};
const hospitalHeaders = (hospitalId?: string) => (hospitalId ? { headers: { 'X-Hospital-Id': hospitalId } } : {});
export { capitalize, truncateText, getEtWeekdayShort, justShowBarriersWeekdaysEt, getDownload, getDateWithFileTypeString, hospitalHeaders };
